import React from "react";
import "./SkillBar.css";

function SkillsBar() {
  return (
    <div className="container">
      <h1 className="text-xl font-bold text-gray-500"> My Skills </h1>
      <div className="skill-box">
        <span className="title font-serif">Photoshop</span>
        <div className="skill-bar">
          <span className="skill-per Photoshop">
            <span className="tooltip font-serif">90%</span>
          </span>
        </div>
      </div>
      <div className="skill-box">
        <span className="title ">Final Cut</span>
        <div className="skill-bar">
          <span className="skill-per Final">
            <span className="tooltip">80%</span>
          </span>
        </div>
      </div>
      <div className="skill-box">
        <span className="title">Studio Photography</span>
        <div className="skill-bar">
          <span className="skill-per Photography">
            <span className="tooltip">85%</span>
          </span>
        </div>
      </div>
      <div className="skill-box">
        <span className="title">Motion Video</span>
        <div className="skill-bar">
          <span className="skill-per Video">
            <span className="tooltip">65%</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default SkillsBar;
